
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8L20 8C20 7.73478 19.8946 7.48043 19.7071 7.29289L19 8ZM14 3L14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2L14 3ZM14 8L13 8L13 9L14 9L14 8ZM9 13C8.44771 13 8 13.4477 8 14C8 14.5523 8.44771 15 9 15L9 13ZM15 15C15.5523 15 16 14.5523 16 14C16 13.4477 15.5523 13 15 13L15 15ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11L13 11ZM11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17L11 17ZM19 20L20 20L19 20ZM6 22L18 22L18 20L6 20L6 22ZM4 4L4 20L6 20L6 4L4 4ZM20 20L20 8L18 8L18 20L20 20ZM14 2L6 2L6 4L14 4L14 2ZM19.7071 7.29289L14.7071 2.29289L13.2929 3.70711L18.2929 8.70711L19.7071 7.29289ZM13 3L13 8L15 8L15 3L13 3ZM14 9L19 9L19 7L14 7L14 9ZM9 15L12 15L12 13L9 13L9 15ZM12 15L15 15L15 13L12 13L12 15ZM13 14L13 11L11 11L11 14L13 14ZM11 11L11 17L13 17L13 11L11 11ZM18 22C19.1046 22 20 21.1046 20 20L18 20L18 20L18 22ZM6 20L4 20C4 21.1046 4.89543 22 6 22L6 20ZM6 4L6 2C4.89543 2 4 2.89543 4 4L6 4Z","fill":"#262D33"}})])
          )
        }
      }
    